import React from 'react'
import { useSelector } from 'react-redux'

import { MenuItemContainer } from '../../mainMenu'
import { getUserInfo, isLoggedIn } from '../store/selectors'

const ProfileMenuItem = () => {
  const { username } = useSelector(getUserInfo)
  const loggedIn = useSelector(isLoggedIn)
  if (!loggedIn) {
    return null
  }
  return (
    <MenuItemContainer
      href={`/account/${username}/`}
      className='nav-profile qa-account-mi'
    >
      Account
    </MenuItemContainer>
  )
}

export default ProfileMenuItem
